export default {
  path: '/order-detail',
  meta: {
    title: '订单详情',
  },
  component: r => require.ensure([], () => r(require(`./index.vue`)), `/order-detail`),
}



// WEBPACK FOOTER //
// ./src/views/OrderDetail/router.js